import { CustomApiException } from '@/modules/core/app/models/CustomApiException';

export class SsoNotConfiguredException extends CustomApiException {
  constructor(model: Partial<SsoNotConfiguredException> = {}) {
    super(model);
  }
}
